export default (price, currency = 'czk') => {
  return Intl.NumberFormat(useNuxtApp()?.$i18n?.locale?.value === 'cs' ? 'cs-CZ' : 'en', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: 0,
  }).format(Number(price));
};
